import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock } from 'lucide-react';
import { blogPosts } from '../content/blog';
import Layout from '../components/Layout';

const BlogList = () => {
  const sortedPosts = [...blogPosts].sort((a, b) => 
    new Date(b.date) - new Date(a.date)
  );

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const estimateReadTime = (content) => {
    const wordsPerMinute = 200;
    const words = content.split(/\s+/).length;
    const minutes = Math.ceil(words / wordsPerMinute);
    return minutes;
  };

  return (
    <Layout>
      <div className="mx-auto max-w-5xl px-4 md:px-8 xl:px-24 2xl:px-32">
        <div className="mb-12">
          <h1 className="text-4xl tracking-tight text-black dark:text-gray-200 sm:text-5xl mb-4">
            Blog
          </h1>
          <p className="text-base text-gray-600 dark:text-gray-400">
            Thoughts on life, faith, work, engineering, and other topics that I'm passionate about.
          </p>
        </div>

        <div className="space-y-6">
          {sortedPosts.map((post) => (
            <article
              key={post.slug}
              className="group relative"
            >
              <Link to={`/blog/${post.slug}`} className="block">
                <div className="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-md transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-gray-200/50 dark:lg:group-hover:bg-gray-800/50 lg:group-hover:shadow-[inset_0_1px_0_0_rgba(148,163,184,0.1)] lg:group-hover:drop-shadow-lg"></div>

                <div className="relative z-10 py-4">
                  <h2 className="text-2xl sm:text-3xl text-black dark:text-gray-200 group-hover:text-blue-600 dark:group-hover:text-blue-300 transition-colors mb-2">
                    {post.title}
                  </h2>

                  <div className="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-500 mb-3">
                    <span className="flex items-center gap-1">
                      <Calendar className="h-4 w-4" />
                      {formatDate(post.date)}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      {estimateReadTime(post.content)} min read
                    </span>
                  </div>

                  <p className="text-base text-gray-600 dark:text-gray-400 mb-4">
                    {post.description}
                  </p>

                  {post.tags && post.tags.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {post.tags.map((tag, index) => (
                        <span
                          key={index}
                          className="rounded-full bg-blue-600/10 dark:bg-blue-400/10 px-3 py-1 text-xs font-medium text-blue-600 dark:text-blue-300"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </Link>
            </article>
          ))}
        </div>

        {sortedPosts.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-600 dark:text-gray-500 text-base">No blog posts yet. Check back soon!</p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default BlogList;
